import Component from '../core/Component'
import EventBus from '../core/EventBus'
import { EVENTS } from '../core/Events'

export default class ButtonsAnimation extends Component {
    prepare() {
        setTimeout(() => {
            this.hydrateButtons()
        }, 2000);
        EventBus.on(EVENTS.DOM_CHANGE, this.handleDomChange)
    }

    destroy() {
        EventBus.off(EVENTS.DOM_CHANGE, this.handleDomChange)
    }

    handleDomChange = () =>{
        this.hydrateButtons()
    }

    hydrateButtons() {
        const buttons = [...document.querySelectorAll('.Button:not(.is-ready)')]
        buttons.forEach(button => {
            const html = button.innerHTML

            if (html) {
                const span = document.createElement('span')
                const children = [...button.childNodes]
                children.forEach(node => {
                    if (!node.classList?.contains('Button-customIcon')) {
                        span.appendChild(node)
                    } else {
                        // .Button-customIcon nechat v rootu .Button
                    }
                })

                const span2 = span.cloneNode(true)
                span2.ariaHidden = 'true'

                button.appendChild(span)
                button.appendChild(span2)
                span.setAttribute('data-hover','orig')
                span2.setAttribute('data-hover','clone')
                button.classList.add('has-animation')
            }

            button.classList.add('is-ready')
        })
    }
}